module.exports = __webpack_public_path__ + "static/media/main-icon.289fe7be.png";